import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logoImage from '../assets/logo/logo.png';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-container">
        <div className="footer-column">
          <div className="footer-logo">
            <img 
              src={logoImage} 
              alt="NQC Logo" 
              className="footer-logo-image"
            />
          </div>
          <p className="footer-description">
            Our expert certification services ensure your business meets and exceeds global standards in quality, safety, and efficiency.
          </p>
        </div>
        
        <div className="footer-column">
          <h3 className="footer-column-title">NQC AGENCY</h3>
          <ul className="footer-links">
            <li><Link to="/system-certification">System Certification</Link></li>
            <li><Link to="/product-certification">Product Certification</Link></li>
            <li><Link to="/quality-certification">Quality Certification</Link></li>
          </ul>
        </div>
        
        <div className="footer-column">
          <h3 className="footer-column-title">EXPLORE OUR PROPERTIES</h3>
          <div className="footer-properties">
            <div className="footer-property">
              <div className="footer-property-image">
                <img 
                  src="/assets/images/fssc-22000.jpg" 
                  alt="FSSC 22000 Certificate"
                  onError={(e) => {
                    // JPG yoksa PNG dene
                    if (e.target.src.includes('.jpg')) {
                      e.target.src = '/assets/images/fssc-22000.png';
                      return;
                    }
                    // PNG de yoksa placeholder göster
                    e.target.style.display = 'none';
                    if (e.target.nextSibling) {
                      e.target.nextSibling.style.display = 'block';
                    }
                  }}
                />
                <span style={{display: 'none'}}>FSSC 22000 Certificate</span>
              </div>
              <h4>FSSC 22000 Certificate</h4>
              <p>Property Info</p>
            </div>
            <div className="footer-property">
              <div className="footer-property-image">
                <img 
                  src="/assets/images/kosher-certificate.jpg" 
                  alt="Kosher Certificate"
                  onError={(e) => {
                    // JPG yoksa PNG dene
                    if (e.target.src.includes('.jpg')) {
                      e.target.src = '/assets/images/kosher-certificate.png';
                      return;
                    }
                    // PNG de yoksa placeholder göster
                    e.target.style.display = 'none';
                    if (e.target.nextSibling) {
                      e.target.nextSibling.style.display = 'block';
                    }
                  }}
                />
                <span style={{display: 'none'}}>Kosher Certificate</span>
              </div>
              <h4>Kosher Certificate</h4>
              <p>Property Info</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Nova Quality Certification Agency. All rights reserved.</p>
        <Link to="/login" className="footer-login-link">Admin Login</Link>
      </div>
    </footer>
  );
};

export default Footer;

